import {
  CCSD_CHANGES_BULK_CHECK_REQUEST,
  CCSD_CHANGES_CHECK_SUCCESS,
  CCSD_CHANGES_DELETE_ERROR,
  CCSD_CHANGES_DELETE_REQUEST,
  CCSD_CHANGES_LIST_CLEAR_FILTERS,
  CCSD_CHANGES_LIST_ERROR,
  CCSD_CHANGES_LIST_REQUEST,
  CCSD_CHANGES_LIST_SET_FILTERS,
  CCSD_CHANGES_LIST_SET_PAGE,
  CCSD_CHANGES_LIST_UNLOAD,
  CCSD_CHANGES_LIST_UPDATED,
} from '../constants';
import { hydraPageCount } from '../../helper/apiUtils';
import { removeFiltersFromSession, setFiltersInSession } from '../../routing/filters';

const reducer = (
  state = {
    ccsdChanges: [],
    currentPage: 1,
    pageCount: null,
    isFetchingCcsdChanges: false,
    filters: {},
  },
  action,
) => {
  switch (action.type) {
    case CCSD_CHANGES_LIST_REQUEST:
    case CCSD_CHANGES_BULK_CHECK_REQUEST:
    case CCSD_CHANGES_DELETE_REQUEST:
      return { ...state, isFetchingCcsdChanges: true };
    case CCSD_CHANGES_DELETE_ERROR:
      return { ...state, isFetchingCcsdChanges: false };
    case CCSD_CHANGES_LIST_UPDATED:
      return {
        ...state,
        ccsdChanges: action.data['hydra:member'],
        pageCount: hydraPageCount(action.data),
        isFetchingCcsdChanges: false,
      };
    case CCSD_CHANGES_LIST_SET_PAGE:
      return { ...state, currentPage: action.page };
    case CCSD_CHANGES_LIST_UNLOAD:
      return { ccsdChanges: [], currentPage: 1, pageCount: null, isFetchingCcsdChanges: false, filters: {} };
    case CCSD_CHANGES_LIST_ERROR:
      return { ...state, isFetchingCcsdChanges: false, ccsdChanges: [] };
    case CCSD_CHANGES_LIST_SET_FILTERS:
      setFiltersInSession(action.routeKey || null, action.filters);
      return { ...state, filters: action.filters };
    case CCSD_CHANGES_LIST_CLEAR_FILTERS:
      removeFiltersFromSession(action.routeKey || null);
      return { ...state, filters: {} };
    case CCSD_CHANGES_CHECK_SUCCESS:
      return {
        ...state,
        ccsdChanges: state.ccsdChanges.map((dc) => (dc.id === action.data.id ? action.data : dc)),
      };
    default:
      return state;
  }
};

export default reducer;
